import ConditionalRule from "~/models/conditionalRules/conditionalRule";
import IRepo from "~/interfaces/repo";
import Repo from "~/state/modules/repo";
import IConditionalRuleReferencedControl from "~/models/conditionalRules/referencedControl";
import {TAdvancedFilter} from "./advancedFilter";

export default class AdvancedFilterConditionalRule extends ConditionalRule {
  rootModel: TAdvancedFilter;

  static repo: IRepo<AdvancedFilterConditionalRule> = new Repo('conditionalRules', AdvancedFilterConditionalRule);

  get referencedControl(): IConditionalRuleReferencedControl {
    return this.rootModel.getReferencedControl(this.referenced_control_id);
  }

  getValueString(id: string): string {
    const reference = this.referencedControl || this.builtInReferencedValue;
    return reference.getChoiceComparisonOptions().find((opt) => opt.client_id === id)?.label_title ?? '';
  }
}